const Header = () => {
    return (
        <nav className="main_page_header navbar navbar-light bg-light">
            <div className="container-fluid justify-content-center">
                <span className="navbar-brand mb-0 h1 fs-2">Mancisidor Propiedades</span>
            </div>
        </nav>
    );
};

export default Header;